import { Helmet } from "react-helmet-async";

export const SITE_URL = "https://www.shinefabric.co";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/assets/shine-logo.png`;
const DEFAULT_DESC =
  "SHINE FABRIC — trendy, comfy clothes for kids. Premium boys & girls wear designed, manufactured and delivered with love from Tirupur, India.";

export function Seo({ title, description, path, image, type = "website", jsonLd, noindex = false }) {
  const canonicalPath = path ?? (typeof window !== "undefined" ? window.location.pathname : "");
  const canonical = `${SITE_URL}${canonicalPath}`;
  const img = image ? (image.startsWith("http") ? image : `${SITE_URL}${image}`) : DEFAULT_OG_IMAGE;
  const desc = description || DEFAULT_DESC;
  const blocks = Array.isArray(jsonLd) ? jsonLd.filter(Boolean) : jsonLd ? [jsonLd] : [];
  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex,follow" />}
      <meta property="og:site_name" content="SHINE FABRIC" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content={type} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(b)}</script>
      ))}
    </Helmet>
  );
}
